import { EventEmitter } from '@angular/core';
import './stacking-plan.scss';
var StackingPlanComponent = /** @class */ /*@__PURE__*/ (function () {
    function StackingPlanComponent() {
        this.onClickSpace = new EventEmitter();
    }
    return StackingPlanComponent;
}());
export { StackingPlanComponent };
